<template>
  <ib-guided-tour
    tour-name="businessGuideTour"
    :steps="tourSteps"
    :show-intro-dialog="showIntroDialog"
    :intro-delay="1000"
    @tour-start="$emit('tour-start')"
    @tour-end="$emit('tour-end')"
    @intro-skip="$emit('intro-skip')"
  >
    <template #intro-image>
      <img src="@/assets/img/onboarding/idea.svg" alt="" style="width: 125px;">
    </template>
    <template #intro>
      <h1 class="text-center mb-2 font-outfit-semi-bold">
        {{ $t('pages.businessGuide.tour.introTitle') }}
      </h1>
      <p class="text-center" style="font-size: 18px;">
        {{ $t('pages.businessGuide.tour.introText') }}
      </p>
    </template>
  </ib-guided-tour>
</template>

<script>
export default {
  name: 'GuideTour',

  props: {
    showIntroDialog: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    tourSteps () {
      return [
        {
          target: '#main-navigation',
          header: { title: this.$t('pages.businessGuide.tour.step1Title') },
          content: this.$t('pages.businessGuide.tour.step1Content'),
          params: {
            placement: 'bottom',
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: '.ai-buddy-button',
          header: { title: this.$t('pages.businessGuide.tour.step2Title') },
          content: this.$t('pages.businessGuide.tour.step2Content'),
          params: {
            placement: 'left',
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: '.v-input__slot',
          header: { title: this.$t('pages.businessGuide.tour.step3Title') },
          content: this.$t('pages.businessGuide.tour.step3Content'),
          params: {
            placement: 'bottom',
            enableScrolling: false,
            highlight: true
          }
        }
      ]
    }
  }
}
</script>
